// eslint-disable-next-line import/prefer-default-export
export const SET_POSITION = 'SET_POSITION';




// WEBPACK FOOTER //
// ./src/app/position/constants.js